import * as tslib_1 from "tslib";
import { BaseModel } from '../_base/model.class';
var Supplier = /** @class */ (function (_super) {
    tslib_1.__extends(Supplier, _super);
    function Supplier(_id, name, companyName, vatNumber, taxCode, legalAddress, operativeAddress, categories, verified, contactPerson, pec, email, phone, fax, webSiteUrl, properties, companies, employees, vc, durc, dvr, rspp, ris, pos, createdBy, createdAt, updatedBy, updatedAt) {
        var _this = _super.call(this) || this;
        _this._id = _id;
        _this.name = name;
        _this.companyName = companyName;
        _this.vatNumber = vatNumber;
        _this.taxCode = taxCode;
        _this.legalAddress = legalAddress;
        _this.operativeAddress = operativeAddress;
        _this.categories = categories;
        _this.verified = verified;
        _this.contactPerson = contactPerson;
        _this.pec = pec;
        _this.email = email;
        _this.phone = phone;
        _this.fax = fax;
        _this.webSiteUrl = webSiteUrl;
        _this.properties = properties;
        _this.companies = companies;
        _this.employees = employees;
        _this.vc = vc;
        _this.durc = durc;
        _this.dvr = dvr;
        _this.rspp = rspp;
        _this.ris = ris;
        _this.pos = pos;
        _this.createdBy = createdBy;
        _this.createdAt = createdAt;
        _this.updatedBy = updatedBy;
        _this.updatedAt = updatedAt;
        _this.setRequiredFields([
            '_id',
            'name',
            'vatNumber',
            'legalAddress',
            'categories',
            // 'properties',
            'verified',
            'createdBy',
            'createdAt',
        ]);
        return _this;
    }
    /**
     * Check if supplier is verified or not
     *
     * @since 1.0.0
     */
    Supplier.prototype.isVerified = function () {
        return this.verified;
    };
    return Supplier;
}(BaseModel));
export { Supplier };
